import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setLogoutCallback } from "../services/http/httpRequest";
import genericUtility from "../services/utility/GenericUtility";

/**
 * Registers a universal 401 auto-logout handler.
 *
 * Mount this hook once inside a component that lives within <Router> (e.g. the
 * inner AppInner component in App.tsx). Whenever any HTTP request returns a
 * 401, the user is automatically logged out and redirected to /home.
 *
 * No changes are needed in individual API service files or page components.
 */
export function useAutoLogout(): void {
  const navigate = useNavigate();

  useEffect(() => {
    setLogoutCallback(() => {
      genericUtility.logout(navigate);
    });

    // Clean up on unmount so the stale navigate reference is never called
    return () => {
      setLogoutCallback(null);
    };
  }, [navigate]);
}

export default useAutoLogout;
